/* ABSCENTS v117 — Reseñas de Judge.me con el estilo de la casa.
   Agrega la nota promedio en serif, deja el conteo en "N reseñas" y
   titula la sección "Reseñas". El estilo vive en abx-ficha.css.
   Idempotente: se reaplica si Judge.me vuelve a pintar el widget. */
(function () {
  'use strict';

  function formato(n) {
    var v = Math.round(parseFloat(n) * 10) / 10;
    if (!isFinite(v) || v <= 0) return '';
    return v.toFixed(1);
  }

  function pulir(widget) {
    var raiz = widget.querySelector('.jdgm-rev-widg');
    if (!raiz) return;
    var total = parseInt(raiz.getAttribute('data-number-of-reviews') || '0', 10);
    var nota = formato(raiz.getAttribute('data-average-rating'));

    var escribir = widget.querySelector('.jdgm-write-rev-link');
    if (escribir && /write a review/i.test(escribir.textContent)) escribir.textContent = 'Escribir una reseña';

    var titulo = widget.querySelector('.jdgm-rev-widg__title');
    if (titulo && titulo.textContent.trim() !== 'Reseñas') titulo.textContent = 'Reseñas';

    var interior = widget.querySelector('.jdgm-rev-widg__summary-inner');
    if (interior && total > 0 && nota && !interior.querySelector('.abx-jdgm-nota')) {
      var el = document.createElement('div');
      el.className = 'abx-jdgm-nota';
      el.setAttribute('aria-label', 'Calificación promedio ' + nota + ' de 5');
      el.textContent = nota;
      interior.insertBefore(el, interior.firstChild);
    }

    if (total > 0) {
      var texto = widget.querySelector('.jdgm-rev-widg__summary-text');
      var destino = texto && (texto.querySelector('a') || texto);
      var deseado = total === 1 ? '1 reseña' : total + ' reseñas';
      if (destino && destino.textContent.trim() !== deseado) destino.textContent = deseado;
    }

    widget.querySelectorAll('.jdgm-rev').forEach(megusta);
  }

  /* ABSCENTS v120 — "Me gusta" de cada reseña. Lee los votos útiles que Judge.me ya trae en la
     reseña y, al tocarlo, usa el mismo botón de Judge.me (se registra igual que antes). Va en la
     barra de Responder; si la reseña no la tiene, en el renglón de acciones de Judge.me. */
  var PULGAR = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false">' +
    '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path></svg>';

  function votoGuardado(id) {
    try {
      var v = JSON.parse(localStorage.getItem('jdgm_thumb_votes') || '{}') || {};
      return !!(v[id] && v[id].submitted);
    } catch (e) { return false; }
  }

  function megusta(rev) {
    var original = rev.querySelector('.jdgm-rev__thumb-btn.jdgm-rev_thumb-up');
    if (!original) return;
    var destino = rev.querySelector('.abx-rs-barra') || rev.querySelector('.jdgm-rev__actions');
    if (!destino) return;
    var otro = rev.querySelector('.abx-like');
    if (otro && otro.parentNode !== destino) { otro.parentNode.removeChild(otro); otro = null; }
    var btn = otro;
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'abx-like';
      btn.innerHTML = PULGAR + '<span class="abx-like__n"></span>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = rev.getAttribute('data-review-id');
        if (rev.__abxVoto || votoGuardado(id)) return;
        rev.__abxVoto = true;
        var u = rev.querySelector('.jdgm-rev__thumb-btn.jdgm-rev_thumb-up');
        if (u) u.click();
        megusta(rev);
      });
      destino.appendChild(btn);
    }
    var cuenta = rev.querySelector('.jdgm-rev_thump-up-count');
    var n = parseInt(cuenta ? (cuenta.getAttribute('data-thumb-count') || cuenta.textContent) : '0', 10) || 0;
    var visto = parseInt((cuenta && cuenta.textContent) || '0', 10) || 0;
    if (visto > n) n = visto;
    var texto = String(n);
    var num = btn.querySelector('.abx-like__n');
    if (num.textContent !== texto) num.textContent = texto;
    var hecho = !!rev.__abxVoto || votoGuardado(rev.getAttribute('data-review-id'));
    if (btn.classList.contains('is-on') !== hecho) btn.classList.toggle('is-on', hecho);
    var etiqueta = (hecho ? 'Te gustó esta reseña' : 'Me gusta esta reseña') + ', ' + texto;
    if (btn.getAttribute('aria-label') !== etiqueta) btn.setAttribute('aria-label', etiqueta);
    btn.setAttribute('aria-pressed', hecho ? 'true' : 'false');
  }

  function revisar() {
    document.querySelectorAll('.jdgm-review-widget').forEach(function (w) {
      pulir(w);
      if (w.__abxObs) return;
      w.__abxObs = true;
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () { pendiente = false; pulir(w); });
      }).observe(w, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revisar);
  } else {
    revisar();
  }
  window.addEventListener('load', revisar);
  setTimeout(revisar, 2500);
})();
